import { API_BASE_URL, motogoFetch } from './api';

interface IceServerResponse {
  urls: string[];
  username?: string | null;
  credential?: string | null;
}

/**
 * Fetches the ICE server config (STUN + TURN with current-env credentials) from the backend.
 * Strips null fields so the result is shaped exactly like the browser's RTCIceServer interface.
 * Throws on non-2xx; callers decide whether to fall back.
 */
export async function fetchIceServers(): Promise<RTCIceServer[]> {
  const response = await motogoFetch(`${API_BASE_URL}/ice-servers`);
  if (!response.ok) {
    throw new Error(`fetchIceServers: HTTP ${response.status}`);
  }
  const raw = (await response.json()) as IceServerResponse[];

  return raw.map(({ urls, username, credential }) => {
    const server: RTCIceServer = { urls };
    if (username) server.username = username;
    if (credential) server.credential = credential;
    return server;
  });
}
